import searchIcon from "images/search.png"
import React from "react"
import Autocomplete from "react-google-autocomplete"
import { withScriptjs } from "react-google-maps"
import { geocodeByPlaceId } from "react-google-places-autocomplete"
import "./placesAutocomplete.scss"

const PlacesAutocomplete = withScriptjs(props => {
  const placeChanged = params => {
    if (params.name === "") {
      props.placeChanged(null)
      return
    }

    geocodeByPlaceId(params.place_id).then(
      response => {
        const geoCoor = {
          lat: response[0].geometry.location.lat(),
          lng: response[0].geometry.location.lng(),
        }
        const fullPlace = response[0].formatted_address
        props.placeChanged(geoCoor, fullPlace)
      },
      error => {
        console.error(error)
      }
    )
  }

  const placeFocused = () => {
    props.setValue(null)
  }

  return (
    <div className="google-places-autocomplete-wrapper">
      <Autocomplete
        className="auto-complete"
        defaultValue={props.defaultValue}
        googleMapsScriptBaseUrl="https://maps.googleapis.com/maps/api/place/autocomplete/"
        onFocus={placeFocused}
        onPlaceSelected={placeChanged}
        options={{
          componentRestrictions: { country: "us" },
          types: ["geocode", "establishment"],
        }}
        placeholder="Enter your state/city or zip code "
      />
      <button className="search-icon-button">
        <img alt="Search" className="search-icon" src={searchIcon} />
      </button>
    </div>
  )
})

export default PlacesAutocomplete
